import { styled, Box, ListItem, List, Button } from '@mui/material'
import theme from 'lib/theme'

export const TimelineContainer = styled(List)(() => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  marginTop: theme.spacing(2),
  paddingBottom: 0,
  '::after': {
    backgroundColor: theme.palette.neutral.grey10,
    content: '""',
    position: 'absolute',
    left: theme.spacing(2),
    width: '2px',
    height: '100%',
  },
}))

export const TimelineItem = styled(ListItem)(() => ({
  display: 'flex',
  justifyContent: 'flex-start',
  position: 'relative',
  paddingBottom: `${theme.spacing(2)}`,
  paddingLeft: `${theme.spacing(6)}`,
}))

export const TimelineCircle = styled(Box)(() => ({
  backgroundColor: theme.palette.commonColors.white,
  border: `2px solid ${theme.palette.neutral.grey10}`,
  borderRadius: '50%',
  position: 'absolute',
  left: `calc(${theme.spacing(2)} / 2 + 1px)`,
  top: 0,
  width: theme.spacing(2),
  height: theme.spacing(2),
  zIndex: '100',
}))

export const AddNoteBtn = styled(Button)(() => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  backgroundColor: theme.palette.neutral.grey9,
  color: theme.palette.commonColors.black,
  border: `1px solid ${theme.palette.neutral.grey7}`,
  ':hover': {
    backgroundColor: theme.palette.neutral.grey8,
  },
}))
